import type { ToggleBookmarkFulfilledAction } from "domains/bookmarks/actionTypes";
import { BookmarkActionTypes } from "domains/bookmarks/actionTypes";
import type { ToggleBookmarkMeta } from "domains/bookmarks/types";

export const toggleBookmarkFulfilled = (meta: ToggleBookmarkMeta): ToggleBookmarkFulfilledAction => ({
  type: BookmarkActionTypes.BOOKMARK_TOGGLE_FULFILLED,
  meta,
});
